import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
let userInfoStr = localStorage.getItem("dnn_dnnCloud_admin_userInfo");
export default new Vuex.Store({
    state:{
        token:'',
        userInfo: userInfoStr? JSON.parse(userInfoStr): '',
        opened: true,   // 菜单是否展开
    },

    getters: {
        userInfo: state => state.userInfo || (localStorage.getItem("dnn_dnnCloud_admin_userInfo") ? JSON.parse(localStorage.getItem("dnn_dnnCloud_admin_userInfo")) : ''),
        opened: state => state.opened
    },

    mutations:{
        set__token(state,token){
            state.token = token
            sessionStorage.token = token
        },
        del__token(state){
            state.token = ''
            sessionStorage.removeItem('token')
        },
        set__userinfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem("dnn_dnnCloud_admin_userInfo", JSON.stringify(userInfo))
        },

        toggle__SideBar(state) {
            console.log('state==', state)
            state.opened = !state.opened
            console.log('state.opened==', state.opened)
        }

    }
})



// WEBPACK FOOTER //
// ./src/store/index.js